import { useEffect, useState } from 'react';

export default function UnitsTab({ units, onSaveUnit, onDeleteUnit }) {
    const [selectedId, setSelectedId] = useState(null);
    const [name, setName] = useState('');

    useEffect(() => {
        if (selectedId === null) {
            setName('');
            return;
        }

        const unit = units.find((item) => item.id === selectedId);
        if (unit) {
            setName(unit.name);
        }
    }, [selectedId, units]);

    const handleSubmit = (event) => {
        event.preventDefault();
        const trimmedName = name.trim();
        if (!trimmedName) return;

        onSaveUnit({ id: selectedId, name: trimmedName });
        setSelectedId(null);
        setName('');
    };

    return (
        <div className="space-y-6">
            <section className="rounded-3xl border border-green-400 bg-green-50/90 p-5 shadow-xl shadow-slate-950/20">
                <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <p className="text-sm uppercase tracking-[0.35em] text-green-400">Unités</p>
                        <h2 className="text-3xl font-semibold text-green-900">Gestion des unités</h2>
                    </div>
                    <p className="max-w-xl text-sm text-green-600">
                        Créez, modifiez et supprimez les unités utilisées dans les ingrédients et l’approvisionnement.
                    </p>
                </div>
            </section>

            <div className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
                <div className="space-y-4">
                    {units.map((unit) => (
                        <div
                            key={unit.id}
                            className="rounded-3xl border border-green-400 bg-white p-5 shadow-xl shadow-slate-950/20"
                        >
                            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                <div>
                                    <p className="text-lg font-semibold text-green-900">{unit.name}</p>
                                </div>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => setSelectedId(unit.id)}
                                        className="rounded-3xl border border-green-300 bg-green-50 px-4 py-2 text-sm text-green-800 hover:border-green-500"
                                    >
                                        Éditer
                                    </button>
                                    <button
                                        onClick={() => onDeleteUnit(unit.id)}
                                        className="rounded-3xl border border-rose-500 bg-red-100 px-4 py-2 text-sm text-rose-500 hover:bg-rose-200"
                                    >
                                        Supprimer
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                    {!units.length && (
                        <div className="rounded-3xl border border-green-400 bg-white p-5 text-green-700 shadow-xl shadow-slate-950/20">
                            Aucune unité définie pour le moment.
                        </div>
                    )}
                </div>

                <div className="rounded-3xl border border-green-400 bg-white p-5 shadow-xl shadow-slate-950/20">
                    <h3 className="mb-4 text-xl font-semibold text-green-900">
                        {selectedId ? 'Modifier une unité' : 'Ajouter une unité'}
                    </h3>
                    <form className="space-y-4" onSubmit={handleSubmit}>
                        <div>
                            <label className="text-sm text-green-600">Nom de l’unité</label>
                            <input
                                value={name}
                                onChange={(event) => setName(event.target.value)}
                                className="mt-2 w-full rounded-3xl border border-green-400 bg-green-50 px-4 py-3 text-green-900 focus:border-green-500 focus:outline-none"
                                placeholder="Ex. kg, L, pièce"
                            />
                        </div>
                        <div className="flex gap-3">
                            <button
                                type="submit"
                                className="rounded-3xl bg-green-600 px-5 py-3 font-semibold text-slate-950 hover:bg-green-500"
                            >
                                Enregistrer
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectedId(null);
                                    setName('');
                                }}
                                className="rounded-3xl border border-green-300 bg-green-50 px-5 py-3 text-green-800 hover:border-green-500"
                            >
                                Annuler
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
